// Constants
import replaceSelectionWithText from './replaceSelectionWithText';

// There's a bug in the rich utils that will throw errors if you try to insert a soft newline with a selection
// So first remove the selection, then insert the soft newline
export default replaceSelectionWithText('\n');
